import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        item: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'center',
            alignSelf: 'stretch',
            gap: 'xsmall-1.base',
            px: remCalc(0),
            marginY: 0,
            paddingY: 'xsmall-1.base',
            color: 'text.default',
            borderBottom: 'small',
            borderColor: 'border.light',
        },
        itemButton: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            cursor: 'pointer',
            textAlign: 'left',
            color: 'foreground.neutral.default',
        },
    },
}
